import(/* webpackMode: "eager" */ "/vercel/path1/node_modules/.pnpm/next@14.2.5_react-dom@19.1.0_react@19.1.0__react@19.1.0_sass@1.80.5/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/vercel/path1/src/components/ui/accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DialogClose"] */ "/vercel/path1/src/components/ui/dialog.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path1/src/feature/routes/plan/index.module.scss");
